<script setup lang="ts">
import heartGif from '../assets/icon/heart.gif';
import starsGif from '../assets/icon/stars.gif';
import thumbsupGif from '../assets/icon/thumbsup.gif';
import tickGif from '../assets/icon/tick.gif';

const gifs = [heartGif, starsGif, thumbsupGif, tickGif];
const randomGif = gifs[Math.floor(Math.random() * gifs.length)];
</script>

<template>
  <div class="success-visual">
    <div class="icon-container" aria-hidden="true">
      <img :src="randomGif" alt="success" class="success-gif" />
    </div>
    <h2 class="title">
      <slot name="title" />
    </h2>
  </div>
</template>

<style scoped lang="less">
.success-visual {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.icon-container {
  margin-bottom: 2rem;
}

.success-gif {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.title {
  font-weight: @font-weight-regular !important;
}
</style>
